export const CLASS_ACTIVITY_TEMPLATE = `<b>Key activities completed:</b>

<b>• Main activity</b> — [e.g., "Recitation of Surah Al-Mulk verses 1-10 with Tajweed application"]
<b>• Secondary activity</b> — [e.g., "Practice of Madd rules with examples"]

The student showed [good engagement / steady focus / strong participation] throughout the session. Areas of strength noted: [STRENGTH]. Areas needing further attention: [AREA TO IMPROVE].`;

export const HOMEWORK_TEMPLATE = `<b>To reinforce today's lesson, please complete the following before our next class:</b>

<b>1. Review and practice:</b> [SPECIFIC CONTENT — e.g., "Surah Al-Mulk verses 1-10"] — [minimum 5 times] daily.
<b>2. Focus on:</b> [SPECIFIC SKILL — e.g., "Applying Madd Tabee'i correctly in the assigned verses"].
<b>3. Prepare for next session:</b> [WHAT TO PREPARE — e.g., "Memorize verses 11-15" / "Read pages 12-14 from the workbook"].`;

export const PLACEHOLDER_REGEX = /\[[^\]\n]+\]/g;
